var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5986 4.50305C17.4441 2.50194 14.5559 2.50195 13.4014 4.50305L1.86426 24.5008C0.710417 26.5008 2.15384 29 4.46282 29H27.5372C29.8462 29 31.2896 26.5008 30.1357 24.5008L18.5986 4.50305Z",
    stroke: "#424754",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 23,
    r: 2,
    fill: "#424754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.11 11.0995C14.0511 10.5108 14.5134 10 15.105 10H16.895C17.4866 10 17.9489 10.5108 17.89 11.0995L17.09 19.0995C17.0389 19.6107 16.6088 20 16.095 20H15.905C15.3912 20 14.9611 19.6107 14.91 19.0995L14.11 11.0995Z",
    fill: "#424754"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnIcon);
export default __webpack_public_path__ + "static/media/WarnIcon.6220743918de71f06d4940de352425ed.svg";
export { ForwardRef as ReactComponent };